// Define a new class that extends the HTMLElement
class AgeGateButton extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", function () {
      localStorage.setItem("age", "true");
      // Get the element with the id 'age-gate-modal'
      const modal = document.getElementById("age-gate-modal");
      if (modal) {
        modal.classList.add("hidden");
      }
    });
  }
}

// Define the new custom element
customElements.define("age-gate-button", AgeGateButton);

// Check if 'age' in localStorage is true
if (localStorage.getItem("age") !== "true") {
  // Get the element with the id 'age-gate-modal'
  const modal = document.getElementById("age-gate-modal");

  if (modal) {
    modal.classList.remove("hidden");
  }
}
